import { render, staticRenderFns } from "./CampaignCreatePage.vue?vue&type=template&id=5b3b5a46"
import script from "./CampaignCreatePage.vue?vue&type=script&lang=js"
export * from "./CampaignCreatePage.vue?vue&type=script&lang=js"
import style0 from "./CampaignCreatePage.vue?vue&type=style&index=0&id=5b3b5a46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports